<div fxLayout="column" fxFlex="100" fxLayoutAlign="start center">
  <div fxLayout="row" fxLayoutAlign="space-between" style="margin-top: 20px" class="buttons" fxLayoutGap="10px">
    <button
      class="btn-week"
      (click)="previousWeek()"
      [ngClass]="{
        disabled: disabled || !week || !year || (minWeek >= week && minYear === year) || minYear > year || !isLoaded || !zip,
      }"
    >
      Previous Week
    </button>
    <button class="btn-week" [ngClass]="{ disabled: disabled || !isLoaded || !zip }" (click)="nextWeek()">Next Week</button>
  </div>
  <div class="days-wrapper {{ showError ? 'error' : '' }}" fxLayout="row" fxLayoutAlign="space-between center">
    @if ((dates?.length ?? 0) > 0) {
      <div fxLayout="row" fxLayout.lt-md="row wrap" fxLayoutAlign="center" fxLayoutGap="10px" fxLayoutGap.lt-md="5px">
        @for (day of dates; track day.date; let i = $index) {
          <div
            class="day"
            [ngClass]="{
              disabled: disabled || disableDates.includes(day.date) || !isLoaded || !zip || beforeMin(day.date),
              'hidden-xs hidden-sm': i === 6 && (!zip || beforeMin(day.date)),
              'no-zip': !zip,
              loaded: isLoaded,
            }"
            fxFlex.lt-md="calc(25% - 5px)"
          >
            <span class="day-name">{{ day.date | date: 'EEE' }}</span>
            <span class="date">{{ day.date | date: 'MMM d' }}</span>

            <div class="part-of-day" fxLayoutAlign="center center" fxLayout="column">
              <button
                [ngClass]="{
                  'filled-btn': day.date === selectedDate.date && selectedDate.partOfDay === partsOfDay.am,
                  available: isLoaded && zip && day.am && !beforeMin(day.date),
                  unavailable: isLoaded && zip && !day.am,
                  disabled: beforeMin(day.date) || disabled || disableDates.includes(day.date),
                }"
                [disabled]="disabled || !zip || beforeMin(day.date) || disableDates.includes(day.date) || (showHourlySlots && !day.am)"
                [title]="!zip ? 'Enter Address' : day.am && !beforeMin(day.date) ? 'Available' : 'Unavailable'"
                type="button"
                (click)="selectDate(day.date, partsOfDay.am)"
              >
                AM{{
                  showHourlySlots
                    ? selectedDate.date === day.date && selectedDate.partOfDay === partsOfDay.am && selectedDate.hour_slot
                      ? ': ' + _24hTo12h(selectedDate.hour_slot) + ':00'
                      : ' >'
                    : ': 08-12'
                }}
              </button>
              <button
                [ngClass]="{
                  'filled-btn': day.date === selectedDate.date && selectedDate.partOfDay === partsOfDay.pm,
                  available: isLoaded && zip && day.pm && !beforeMin(day.date),
                  unavailable: isLoaded && zip && !day.pm,
                  disabled: beforeMin(day.date) || disabled || disableDates.includes(day.date),
                }"
                [disabled]="disabled || !zip || beforeMin(day.date) || disableDates.includes(day.date) || (showHourlySlots && !day.pm)"
                [title]="day.pm && !beforeMin(day.date) ? 'Available' : 'Unavailable'"
                type="button"
                (click)="selectDate(day.date, partsOfDay.pm)"
              >
                PM{{
                  showHourlySlots
                    ? selectedDate.date === day.date && selectedDate.partOfDay === partsOfDay.pm && selectedDate.hour_slot
                      ? ': ' + _24hTo12h(selectedDate.hour_slot) + ':00'
                      : ' >'
                    : ': 12-04'
                }}
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <p class="selected-date-label date" fxLayoutAlign="start center">
    Selected Date:
    <span [ngClass]="{ error: showError }">
      {{ selectedDate.date ? (selectedDate.date | date: 'MMM d, y') : 'Please select date' }}
    </span>
  </p>
  <p class="selected-date-label time" fxLayoutAlign="start center">
    Selected Time:
    <span>{{ selectedTimeLabel }}</span>
  </p>

  @if (!selectedAvailable && !pastDate) {
    <p>
      <rspl-info-box
        type="warning"
        message="This date is not available according to the current availability setup! It can be used regardlessly, but needs to be approved by your supervisor"
      ></rspl-info-box>
    </p>
  }
  @if (inZoneRequired && zip) {
    <p>
      <rspl-info-box
        type="warning"
        header="This charity does not accept out-of-zone pickups"
        message="The donor's address falls outside the zone this charity requires, so a pickup cannot be scheduled for
        them. Assign a different charity, or let the donor know we are unable to cover this address."
      ></rspl-info-box>
    </p>
  } @else if (outOfZone && zip) {
    <p>
      <rspl-info-box
        type="important"
        header="Donor Out of Zone"
        message="This donor is outside our standard service area. While you can submit the pickup request, please note that
        completion is not guaranteed. We’ll let the donor know that we will check for any available pickup dates and
        update them accordingly."
      ></rspl-info-box>
    </p>
  }
</div>

<ng-template #AvailableHours>
  <h2 mat-dialog-title>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-icon>schedule</mat-icon>
      </div>
      <div>
        <span fxLayout="row">Please select your prefered time slot</span>
      </div>
    </div>
  </h2>
  <div mat-dialog-content [ngClass]="{ 'captain-app': config.isCaptain }">
    <div class="part-of-day-hourly" fxLayout="row" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="11px">
      @for (slot of hoursDialogData.available; track slot) {
        <button
          (click)="hoursDialogData.hour_slot = slot.hour"
          [ngClass]="{ 'filled-btn': hoursDialogData.hour_slot === slot.hour }"
          class="available time-slot"
        >
          {{ slot.label }}
        </button>
      }
    </div>
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
      <button class="primary-btn" (click)="availableHoursDialog?.close(false)" cdkFocusInitial>Cancel</button>
      <button
        class="primary-btn filled-btn confirm-btn"
        [disabled]="!hoursDialogData.hour_slot"
        (click)="availableHoursDialog?.close(true)"
        cdkFocusInitial
      >
        Confirm
      </button>
    </div>
  </div>
</ng-template>
